import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import BasketLineItemImage from '@/ui/views/checkout/BasketLineItemImage.vue';
import BasketLineItemProperties from '@/ui/views/checkout/BasketLineItemProperties.vue';
import BasketLineItemTitle from '@/ui/views/checkout/BasketLineItemTitle.vue';
import BasketFreeItemViewObject = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Consumer.BasketFreeItemViewObject;


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketFreeItem',
  props: {
    model: null
  },
  setup(__props: any) {



function addFreeItem() : Promise<void> {
    return store.dispatch('basket/addFreeItem');
}

return { __sfc: true,addFreeItem, BasketLineItemImage, BasketLineItemTitle }
}

})